export const adsTableHeaderWithoutSubSection = ['STATUS','BANNERS','LOCATION','START DATE/TIME','END DATE/TIME'];
export const adsTableHeaderWithSubSection = ['Select','BANNERS','SUBSECTION','LOCATION','FROM ','TO'];

export function setSessionStorage(key, value) {
    window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function getSessionStorage(key) {
    return window.sessionStorage.getItem(key)
}

export function deleteFromSessionStorage(key) {
    return window.sessionStorage.removeItem(key);
}
export default function delete_cookie(name) {
    setCookie(name,'',1);
};
export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
}

export function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function ceGetClosestElement() {
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            let el = this;
            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
}

export function addClass(element, className) {
    if (element && className && !element.classList.contains(className)) {
        element.classList.add(className);
    }
    return undefined;
}

export function removeClass(element, className) {
    if (element && className && element.classList.contains(className)) {
        element.classList.remove(className);
    }
    return undefined;
}
export function toggleClass(element, className) {
    if (!element.classList.contains(className)) {
        element.classList.add(className);
    } else {
        element.classList.remove(className);
    }
}
export function timeFormat(currentDate,format,seprator) {
    format = format || 'h:m:s';
    seprator = seprator || ':';
    if(currentDate){
        let dt = new Date(currentDate);
        switch (format) {
            case 'H:M:S':
            case 'h:m:s' :
                dt = dt.getHours()+seprator+dt.getMinutes()+seprator+dt.getSeconds();
                break;
            case 'h:m':
                dt = dt.getHours()+seprator+dt.getMinutes();
                break;
            case 'm:s':
                dt = dt.getMinutes()+seprator+dt.getSeconds();
                break;
            default :  dt = dt.getHours()+seprator+dt.getMinutes()+seprator+dt.getSeconds();

        }
        return dt.toString();
    }
    return null;
}
export function mobileDeviceCheck() {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
export function getNextOneYearDate(value) {
    let dt = new Date(value) || new Date();
    let year = dt.getFullYear() + 1;
    let month = dt.getMonth();
    let date = dt.getDate();
    return new Date(year, month, date);
}
export function subDays(date,days) {
    date = date || new Date();
    date.setDate(date.getDate()-days);
    return new Date(date);

}
export function addDays(date,days) {
    date = date || new Date();
    date.setDate(date.getDate()+days);
    return new Date(date);

}
export function dateFormat(currentDate, format, seprator) {
    format = format || 'd-M-Y';
    seprator = seprator || '-';

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    if (currentDate != null) {
        let dt = new Date(currentDate);
        switch (format) {
            case 'd-M-Y':
            case 'd M Y':
                dt = dt.getDate() + seprator + monthNames[dt.getMonth()] + seprator + dt.getFullYear();
                break;
            case 'd M':
                dt = dt.getDate() + seprator + monthNames[dt.getMonth()];
                break;
            case 'M Y':
                dt = monthNames[dt.getMonth()] + seprator + dt.getFullYear();
                break;
            case 'd':
                dt = dt.getDate();
                break;
            case 'M':
                dt = monthNames[dt.getMonth()];
                break;
            case 'M d Y':
                dt = monthNames[dt.getMonth()] + seprator + dt.getDate() + seprator + dt.getFullYear();
                break;
            case 'Y-m-d':
                let month = dt.getMonth()+1;
                dt = dt.getFullYear() + seprator + (month<9?"0"+month:month) + seprator + (dt.getDate()<9?"0"+dt.getDate():dt.getDate());
                break;
            default:
                dt = dt.getDate() + seprator + monthNames[dt.getMonth()] + seprator + dt.getFullYear();
                break;
        }
        return dt.toString();
    }
    return null;
}


